var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-recaptcha',{staticStyle:{"display":"inline-block"},attrs:{"sitekey":"6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI","loadRecaptchaScript":true},on:{"verify":_vm.onCaptchaVerified}})}
var staticRenderFns = []

export { render, staticRenderFns }